"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.goToStep = void 0;
var goToStep = function (args) { return function (step) {
    if (typeof step !== "string" && typeof step !== "number")
        return console.log("Wizard warning: step to go to invalid type, it should be a string or a number");
    return args.setHistory(function (ps) { return __spreadArrays(ps, [step]); });
}; };
exports.goToStep = goToStep;
//# sourceMappingURL=goToStep.js.map